import { translate, objectValueOrDefault, ipCountryQuery, configQuery } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { ValidationDisplay, required, isNumeric, maxLength } from '@gig/magic-form-builder';

function getLoginSmsForm(errorMessage, messageType) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        name: 'step-1',
                        path: 'step-1'
                    };
                    return [4 /*yield*/, smsCode()];
                case 1: return [2 /*return*/, [
                        (_a.components = [_b.sent()],
                            _a.nextButton = {
                                text: translate('login-sms.button'),
                                alwaysEnabled: true,
                            },
                            _a.errorMessage = errorMessage,
                            _a.alwaysShowErrorMessage = messageType === 'error',
                            _a)
                    ]];
            }
        });
    });
}
function smsCode() {
    return __awaiter(this, void 0, void 0, function () {
        var codeLengthConfig, ipCountry, length;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, configQuery('signup.smsCodeLength')];
                case 1:
                    codeLengthConfig = _a.sent();
                    return [4 /*yield*/, ipCountryQuery()];
                case 2:
                    ipCountry = _a.sent();
                    length = objectValueOrDefault(codeLengthConfig, ipCountry);
                    return [2 /*return*/, {
                            id: 'code',
                            serverId: 'code',
                            component: 'magic-ui-form-field',
                            isDataField: true,
                            type: 'text',
                            testId: 'code',
                            properties: {
                                placeholder: translate('login-sms.placeholder'),
                                type: 'number',
                                inputmode: 'numeric',
                            },
                            validationDisplay: ValidationDisplay.OnTouchShowMessage,
                            validation: [
                                {
                                    name: 'required',
                                    fn: required,
                                    message: translate('login-sms.required-error'),
                                },
                                {
                                    name: 'containsNumber',
                                    fn: isNumeric,
                                    message: translate('login-sms.numeric-error'),
                                },
                                {
                                    name: 'max-length',
                                    fn: maxLength(length),
                                    message: translate('login-sms.numeric-error'),
                                },
                            ],
                        }];
            }
        });
    });
}

export { getLoginSmsForm };
